import React from 'react'
import { numberWithCommas } from '../../utils/customFunction'
import moment from 'moment'

function ViewLoanApplication(props) {
    const {
        selectedItems
    } = props
    return (
        <div className='row'>
            <div className='col-md-4'>
                <div className="form-group">
                    <label>Fund Code</label>
                    <div>
                        <input
                            type="text"
                            className={`form-control w-100`}
                            value={selectedItems?.symbol_code}
                        />
                    </div>
                </div>
            </div>
            <div className='col-md-4'>
                <div className="form-group">
                    <label>Fund Name</label>
                    <div>
                        <input
                            type="text"
                            className={`form-control w-100`}
                            value={selectedItems?.fund_name}
                        />
                    </div>
                </div>
            </div>
            <div className='col-md-4'>
                <div className="form-group">
                    <label>Folio No</label>
                    <div>
                        <input
                            type="text"
                            className={`form-control w-100`}
                            value={selectedItems?.folio_no}
                        />
                    </div>
                </div>
            </div>
            <div className='col-md-4'>
                <div className="form-group">
                    <label>Employee Name</label>
                    <div>
                        <input
                            type="text"
                            className={`form-control w-100`}
                            value={selectedItems?.employee_name}
                        />
                    </div>
                </div>
            </div>
            <div className='col-md-4'>
                <div className="form-group">
                    <label>Loan Amount</label>
                    <div>
                        <input
                            type="text"
                            className={`form-control w-100`}
                            value={numberWithCommas(selectedItems?.loan_amount)}
                        />
                    </div>
                </div>
            </div>
            <div className='col-md-4'>
                <div className="form-group">
                    <label>No Of Installments</label>
                    <div>
                        <input
                            type="text"
                            className={`form-control w-100`}
                            value={numberWithCommas(selectedItems?.number_of_installment)}
                        />
                    </div>
                </div>
            </div>
            <div className='col-md-4'>
                <div className="form-group">
                    <label>Created At</label>
                    <div>
                        <input
                            type="text"
                            className={`form-control w-100`}
                            value={moment(selectedItems?.created_at)?.format("DD-MM-YYYY")}
                        />
                    </div>
                </div>
            </div>
            <div className='col-md-4'>
                <div className="form-group">
                    <label>Status</label>
                    <div>
                        <input
                            type="text"
                            className={`form-control w-100`}
                            value={selectedItems?.loan_status}
                        />
                    </div>
                </div>
            </div>

        </div>
    )
}

export default ViewLoanApplication